<template>
  <component
    :is="url ? 'a' : 'div'"
    :href="url || undefined"
    :class="[$style.menuItem, $style[size]]"
    @click="$emit('click')"
  >
    <div v-if="image" :class="$style.menuItemImage">
      <div :class="$style.imageContainer">
        <img
          :src="`/content-static/navigation-menu/${image}.webp`"
          alt="Navigation Furniture"
          :class="[{ [$style.overflowImage]: true, [$style.fullHeightIcon]: fullHeightIcon }]"
          loading="lazy"
        />
      </div>
    </div>
    <div v-else-if="noyellowbar" :class="[$style[size]]" />
    <div v-else :class="[$style.yellowBar, $style[size]]" />
    <div v-if="chevron" :class="$style.menuItemText">
      <slot />
      <img
        v-if="chevron"
        src="/content-static/navigation-menu/chevron-right.svg"
        alt="chevron right"
        loading="lazy"
      />
    </div>
    <slot v-else />
  </component>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "NavMenuItem",
  props: {
    url: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: null
    },
    chevron: {
      type: Boolean,
      default: false
    },
    noyellowbar: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "l",
      validator: (value: string) => ["s", "l"].includes(value)
    },
    fullHeightIcon: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style lang="css" module>
:root {
  --imgHeight: 84%;
  --imgPadding: calc(-1 * calc(100% - var(--imgHeight)) / 2);
}

.menuItem {
  @apply flex flex-row items-center cursor-pointer text-base-dark no-underline w-full;

  &.s {
    @apply h-ds-lg md:h-ds-ml;
  }

  .menuItemImage {
    @apply bg-anyvan-yellow rounded-lg w-[40px] h-[40px] mr-ds-ml relative transition-all;

    .imageContainer {
      @apply w-full h-full relative;
    }

    .overflowImage {
      @apply absolute max-w-none min-h-0 transition-all;
      top: 8%;
      right: -5px;
      height: var(--imgHeight);
      clip-path: inset(var(--imgPadding) 0 var(--imgPadding) calc(100% - 45px) round 8px 0 0 8px);

      &.fullHeightIcon {
        top: 5%;
        height: 95%;
      }
    }
  }

  .yellowBar {
    @apply bg-anyvan-yellow w-0 rounded-md transition-all;

    &.l {
      @apply h-[40px];
    }
    &.s {
      @apply h-ds-lg md:h-ds-ml;
    }
  }

  .menuItemText {
    @apply flex justify-between items-center w-full;
  }

  &:hover {
    @apply text-base-dark no-underline;

    .menuItemImage {
      @apply mr-ds-ml;

      .overflowImage {
        right: -10px;
        clip-path: inset(var(--imgPadding) 0 var(--imgPadding) calc(100% - 50px) round 8px 0 0 8px);
      }
    }

    .yellowBar {
      @apply w-ds-xxs mr-ds-sm;
    }
  }

  &:focus {
    @apply text-base-dark no-underline;
  }
}
</style>
